import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/login";
import Dashboard from "./pages/Dashboard";
import FreeQuantityReport from "./pages/freeQuantityReport";
import CustomerWiseReport from "./pages/CustomerWiseReport";
import ProductProfitabilityReport from "./pages/ProductProfitabilityReport";
import CustomerProfile from "./pages/CustomerProfile";
import SeasonWiseTransactionReport from "./pages/SeasonWiseTransactionReport";
import CentralLocationStockReport from "./pages/CentralLocationStockReport";

/* 🔐 Route Guard */
const ProtectedRoute = ({ isLoggedIn, children }) => {
  return isLoggedIn ? children : <Navigate to="/login" replace />;
};

/* 🔐 Authenticated Area */
const AuthenticatedApp = ({ onLogout }) => {
  return (
    <div className="flex h-screen">
      <Routes>
        <Route path="/dashboard" element={<Dashboard onLogout={onLogout} />} />
        <Route
          path="/reports/free-quantity"
          element={<FreeQuantityReport onLogout={onLogout} />}
        />
        <Route
          path="/reports/customer-wise"
          element={<CustomerWiseReport onLogout={onLogout} />}
        />

        <Route
          path="/reports/Product-Profitability"
          element={<ProductProfitabilityReport onLogout={onLogout} />}
        />

        <Route
          path="/reports/Customer-Profile"
          element={<CustomerProfile onLogout={onLogout} />}
        />

        <Route
          path="/reports/Season-Wise-Transaction"
          element={<SeasonWiseTransactionReport onLogout={onLogout} />}
        />

        <Route
          path="/reports/Central-Location-Stock"
          element={<CentralLocationStockReport onLogout={onLogout} />}
        />

        {/* Default */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </div>
  );
};

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(
    sessionStorage.getItem("isLoggedIn") === "true"
  );

  const handleLoginSuccess = () => {
    sessionStorage.setItem("isLoggedIn", "true");
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("isLoggedIn");
    setIsLoggedIn(false);
  };

  return (
    <BrowserRouter>
      <Routes>
        {/* 🔓 Login */}
        <Route
          path="/login"
          element={
            isLoggedIn ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Login onLoginSuccess={handleLoginSuccess} />
            )
          }
        />

        {/* 🔐 Protected */}
        <Route
          path="/*"
          element={
            <ProtectedRoute isLoggedIn={isLoggedIn}>
              <AuthenticatedApp onLogout={handleLogout} />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
